import { IListItem, IMenuList } from '~/src/dash/types/menuList';

export function CreateMenuList(
  options: string[],
  getTitle: (id: string) => string,
  selected: string[] = [],
): IMenuList {
  const out = {} as IMenuList;

  options.forEach((opt: string) => {
    out[opt] = {
      ID: opt,
      title: getTitle(opt),
      selected: selected.includes(opt),
    };
  });
  return out;
}

export function createUnselectedIMenuList(
  items: any[],
  IDField: string,
  titleField: string,
): IMenuList {
  const out = {} as IMenuList;

  items.forEach((item: any) => {
    out[item[IDField]] = {
      ID: item[IDField],
      title: item[titleField],
      selected: false,
    } as IListItem;
  });

  return out;
}

export function GetSelectedValuesFromMenuList(menuList: IMenuList): string[] {
  return Object.values(menuList)
    .filter((obj) => obj.selected)
    .map((obj) => obj.ID);
}

export function GetSelectedValuesFromMenuListSingle(menuList: IMenuList): string | null {
  const elems = Object.values(menuList)
    .filter((obj) => obj.selected)
    .map((obj) => obj.ID);
  if (elems === null || elems === undefined) {
    return null;
  }
  if (elems.length > 0) {
    return elems[0];
  }
  return null;
}
